import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'

export class DeletePkHierarchyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/deleteHierarchy',
      requesterInfo,
    })
  }

  public async deleteHierarchy(hierarchyCode: string): Promise<string> {
    this.props.url = `${this.props.url}?hierarchyCode=${encodeURIComponent(hierarchyCode)}`
    return await this.deleteAsync<string>()
  }
}
